// extracted by mini-css-extract-plugin
module.exports = {"chip":"Chip_chip__hjLvv","chip--active":"Chip_chip--active__Zwgyy","icon":"Chip_icon__G0zAZ"};